function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#BEB0F4"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M9 12h7v-.06c0-7.44-7-10.5-7-10.5A11.03 11.03 0 002.1 7.2a1 1 0 00.06.96A8 8 0 009 12zm7 .06c-11.5 0-7 10.5-7 10.5 2.44.69 5.05.51 7.38-.5a1 1 0 00.62-.9V19a6 6 0 015.16-5.94.96.96 0 00.84-.95V12h-7v.06z"
}), React.createElement("path", {
  fill: "#7356B6",
  d: "M1.38 17.58c1.57 3 4.34 5.19 7.62 6.04V20a7 7 0 016.1-6.94 1 1 0 00.9-1V12H9a8 8 0 00-7.63 5.58zM23 11.91a1 1 0 00-.84-.96A6 6 0 0117 5V1.09a12.04 12.04 0 00-8-.71V4a7 7 0 006.1 6.95 1 1 0 01.9 1V12h7v-.1z"
}))));